/*
  UMD header generated via modularize.js at 2015-04-14T23:57:20.982Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/jquery.jcarousel': [],
  'minted:html': []
})(this, function (m_module, $) {

var M = m_module.M;

M.carousel = {};

/* carousel functions */

M.carousel.itemLoadCallback = function(carousel, state) {
  if (!carousel.options.data) {
    return;
  }
  for (var i = carousel.first; i <= carousel.last; i++) {
    if (carousel.has(i)) {
      continue;
    }
    if (i > carousel.options.data.length) {
      break;
    }
    carousel.add(i, M.carousel.getItemHTML(carousel.options.data[i - 1]));
  }
};

M.carousel.buildCarouselControls = function(carousel) {
  var html = '<ul class="inline">';
  var len = Math.ceil(carousel.options.size / carousel.options.visible);
  // don't draw controls if not needed
  if (carousel.options.size <= carousel.options.visible) {
    return;
  }
  var CONTROL_ID_PREFIX = 'ctl_';
  for (var i = 0; i < len; i++) {
    var css = '';
    if (i === 0) {
      css = ' active';
    }
    html += '<li><a id="' + CONTROL_ID_PREFIX + i + '">' +
    '<img src="/static/images/sprite_placeholder.png" ' +
    'class="sprite carouselPagination' + css + '" /></a></li>';
  }
  html += '</ul>';

  // This code is problematic. We are selecting from a class globally and
  // expecting the result to be unique. If there is more than one result for
  // controlClassName, we will write this html into more than one place. This
  // has in the past broken other carousels on the page.
  // TODO Refactor this code to accept any valid selector rather than building
  // a class name from the carousel options. Then we could pass in an id or
  // a dom node and have control over this.
  var controlClassName = '.jcarousel-control';
  if (carousel.options.className) {
    controlClassName = '.' + carousel.options.className + 'Control';
  }
  $(controlClassName).html(html);

  // bind click events to controls
  $(controlClassName + ' li a').bind('click', function() {
    var id = $(this).attr('id').substrFromIndex('_');
    var idx = $.jcarousel.intval((id * carousel.options.visible) + 1);
    carousel.scroll(idx);
    var current = Math.round(carousel.first / carousel.options.visible);
    $(controlClassName + ' li a img').removeClass('active');
    $('img', this).addClass('active');
    if (carousel.options.tracking) {
      var trackData = {
        feature: carousel.options.tracking.source,
        event: carousel.options.tracking.event,
        sku: carousel.options.tracking.sku,
        index: idx
      };
      M.sendTrackAPI(trackData);
    }
    return false;
  });

  if (carousel.options.isLazyLoadImage) {
    var lazyLoad = function(page) {
      $('img', page).each(function(i) {
        var image = this;
        if ($(image).attr('data-hidden-src')) {
          image.src = $(image).attr('data-hidden-src');
        }
      });
    };

    // load first item
    lazyLoad($('.jcarousel-item-1'));

    // load other items on mouse hover of page control
    $(controlClassName + ' li a').bind('mouseover', function() {
      var index = parseInt(this.id.substring(CONTROL_ID_PREFIX.length)) + 1;
      var pageClassName = '.jcarousel-item-' + index;
      var page = $(pageClassName);
      lazyLoad(page);
    });
  }
};

M.carousel.getItemHTML = function(data) {
  var html = '<li>';
  html += '<div class="media">';
  html += '<div class="shadowContainer"><div>';
  html += '<a href="/' + data.prod_details_url +
    '"><img class="thumb ' + data.thumbnail_class + '" src="' +
    M.html.htmlAttributeEscape(data.design_thumbnail) +
    '"/></a></div>';
  if (data.designer_id) {
    html += '<div class="bd">';
    html += '<div class="media avatar"><a class="img" href="/search?designerID=';
    html += data.designer_id + '"><img src="';
    html += M.html.htmlAttributeEscape("" + data.designer_photo);
    html += '" /></a>';
    html += '<p class="bd">By <b><a href="';
    html += '/search?designerID=' + data.designer_id;
    html += '"><span class="caption">';
    html += M.html.htmlEscape("" + data.designer_visible_username.truncate(24));
    html += '</span></a></b><br/>';
    html += M.html.htmlEscape("" + data.designer_location.truncate(20));
    html += '</p>';
    html += '</div></div>';
  }
  html += '</div></li>';
  return html;
};

M.carousel.showCurrentItemIndex = function(_carousel, _li, index, _state) {
  this.$('.currentIndex').html(index);
};

return {
};

});
